import { ArrowLeftOutlined, FileAddOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography, message } from "antd";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PRIMARY_RED } from "../../constants/colors";
import { setBreadcrumbItems } from "../../store/actions";

const { Text } = Typography;

const AddForm = ({ setBreadcrumbItems }) => {
  const [formName, setFormName] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const navigate = useNavigate();

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const breadcrumbItems = [
    { title: "Form & Collateral", link: "#" },
    { title: "Form", link: "#" },
    { title: "Add Form", link: "#" }
  ];

  useEffect(() => {
    setBreadcrumbItems("Form", breadcrumbItems);
  }, [setBreadcrumbItems, breadcrumbItems]);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setPdfFile(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "application/pdf": [".pdf"] },
    multiple: false,
  });

  const handleSubmit = async () => {
    if (!formName || !formDescription || !pdfFile) {
      message.error("Please fill all fields and upload a PDF.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("formName", formName);
      formData.append("formDescription", formDescription);
      formData.append("pdfs", pdfFile);

      await axios.post(`${process.env.REACT_APP_API_BASEURL}/form`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      message.success("Form added successfully");
      navigate("/form");
    } catch (error) {
      console.error("Form upload error:", error.response?.data || error.message);
      message.error("Failed to add form");
    }
  };

  return (
    <div className="p-4">
      <Card title="Add Form">
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Form Name</Text>
            <Input
              placeholder="AC / Cooler"
              value={formName}
              onChange={(e) => setFormName(e.target.value)}
              style={{ marginBottom: 20 }}
            />
          </Col>
          <Col span={12}>
            <Text strong>Description</Text>
            <Input
              placeholder="About Form"
              value={formDescription}
              onChange={(e) => setFormDescription(e.target.value)}
              style={{ marginBottom: 20 }}
            />
          </Col>
        </Row>

        <Text strong>Form PDF</Text>
        <div
          {...getRootProps()}
          style={{
            border: "2px dashed #d9d9d9",
            padding: "40px",
            textAlign: "center",
            marginBottom: "20px",
            borderRadius: "8px",
            cursor: "pointer",
            backgroundColor: isDragActive ? "#fafafa" : "#fff",
          }}
        >
          <input {...getInputProps()} />
          <img
            src="https://cdn-icons-png.flaticon.com/512/1828/1828491.png"
            alt="Upload"
            style={{ width: "40px", marginBottom: "10px", opacity: 0.5 }}
          />
          <div style={{ fontWeight: 600, fontSize: "16px" }}>
            {isDragActive ? "Drop the file here..." : "Drop file here to upload"}
          </div>
        </div>

        {pdfFile && (
          <div style={{ marginBottom: 20 }}>
            <Text>
              Selected File:{" "}
              <a
                href={URL.createObjectURL(pdfFile)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {pdfFile.name}
              </a>
            </Text>
          </div>
        )}

        <Row gutter={16}>
          <Col>
            <Button
              type="primary"
              style={{ backgroundColor: PRIMARY_RED }}
              icon={<PlusOutlined />}
              onClick={handleSubmit}
            >
              Add Form
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              style={{ color: PRIMARY_RED }}
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/form")}
            >
              Back
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(AddForm);

